/**
 * Legacy Helper Functions
 */
// Helper validation functions

export function safeTag(string) {
    return string.replace(/[^a-zA-Z0-9 +\-=._:/@]/g, "").substr(0, 255);
}
